<template>
  <div>
    <v-row class="customer-detail custom-border-to">
      <v-col md="12" sm="12" class="pt-0">
        <!-- Loader -->
        <v-skeleton-loader
          class="custom-skeleton"
          v-if="pageLoading"
          type="table-tbody"
        />

        <!-- Table -->
        <v-simple-table v-else class="simple-table">
          <template v-slot:default>
            <!-- HEADER -->
            <thead>
              <tr style="background-color: #f3f6f9; color: #24326d">
                <th class="simple-table-th">Product</th>
                <th class="simple-table-th">Price</th>
                <th class="simple-table-th">Brand</th>
                <th class="simple-table-th">Category</th>
                <th class="simple-table-th">Specification</th>
                <th class="simple-table-th">Modified At</th>
                <th class="simple-table-th">Added Date</th>
                <th class="simple-table-th">Action</th>
              </tr>
            </thead>

            <!-- BODY -->
            <tbody>
              <tr
                v-for="(item, index) in rowData"
                :key="index"
                :class="{
                  'custom-border-top': index == 0,
                  'orange_lighten-5': index % 2 == 0,
                }"
              >
                <!-- Product Name -->
                <td class="font-size-14 font-weight-500">
                  {{ item.product_rel.name }}
                </td>

                <!-- Price -->
                <td class="font-size-14 font-weight-500">$ {{ item.price }}</td>

                <td class="font-size-14 font-weight-500">
                  <template v-if="item?.product_rel?.brand">
                    {{ item.product_rel.brand }}
                  </template>
                  <em v-else class="text-muted"> no brand </em>
                </td>

                <td class="font-size-14 font-weight-500">
                  <template v-if="item?.product_rel?.category">
                    {{ item.product_rel.category }}
                  </template>
                  <em v-else class="text-muted"> no category </em>
                </td>

                <td class="font-size-14 font-weight-500">
                  <template v-if="item?.product_rel?.specification">
                    {{ item.product_rel.specification }}
                  </template>
                  <em v-else class="text-muted"> no specification </em>
                </td>

                <td class="font-size-14 font-weight-500">
                  <template v-if="item.updated_at">
                    {{ formatDateTime(item.updated_at) }}
                  </template>
                  <em v-else class="text-muted"> no modification date </em>
                </td>
                <!-- Date -->
                <td class="font-size-14 font-weight-500">
                  <template v-if="item.added_at">
                    {{ formatDateTime(item.added_at) }}
                  </template>
                  <em v-else class="text-muted"> no added date </em>
                </td>
                <td class="font-size-14 font-weight-500">
                  <div class="d-flex align-center">
                    <v-btn
                      icon
                      small
                      color="cyan"
                      @click="$emit('edit-product', item)"
                    >
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      small
                      color="red"
                      @click="openDeleteDialog(item)"
                    >
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </td>
              </tr>

              <!-- EMPTY -->
              <tr v-if="rowData.length === 0">
                <td colspan="8" class="text-center py-4">
                  <p
                    class="m-0 row-not-found text-center font-weight-500 font-size-16"
                  >
                    <img
                      :src="$assetURL('media/error/empty.png')"
                      class="row-not-found-image"
                    />
                    Uhh... There are no products at the moment.
                  </p>
                </td>
              </tr>
              <Dialog :common-dialog="action_dialog">
                <template v-slot:title> Confirmation </template>

                <template v-slot:body>
                  <v-form ref="form" v-model="formValid">
                    <v-container>
                      <p class="font-size-19 font-weight-600 mx-2 my-0">
                        Are you sure, you want to delete this Product?
                      </p>
                    </v-container>
                  </v-form>
                </template>

                <template v-slot:action>
                  <v-btn
                    depressed
                    class="mx-2 custom-bold-button white--text"
                    color="red"
                    @click="action_submit"
                    :loading="formLoading"
                  >
                    Delete
                  </v-btn>

                  <v-btn
                    depressed
                    :disabled="formLoading"
                    class="mx-2 custom-grey-border custom-bold-button"
                    @click="action_dialog = false"
                  >
                    Cancel
                  </v-btn>
                </template>
              </Dialog>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import CommonMixin from "@/core/plugins/common-mixin";
import { DELETE } from "@/core/services/store/request.module";
import Dialog from "@/view/pages/partials/Dialog.vue";
export default {
  name: "ProductDetail",
  mixins: [CommonMixin],

  props: {
    products: {
      type: Array,
      default: () => [],
    },
    pageLoading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Dialog,
  },

  data() {
    return {
      rowData: [],
      action_dialog: false,
      selected_product: null,
      formLoading: false,
    };
  },

  watch: {
    products: {
      deep: true,
      immediate: true,
      handler() {
        this.assignData();
      },
    },
    pageLoading: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    action_submit() {
      if (!this.selected_product) return;

      this.formLoading = true;

      this.$store
        .dispatch(DELETE, {
          url: `customer-product/${this.selected_product.id}`,
          data: { source: "customer" },
        })
        .then(() => {
          this.action_dialog = false;
          this.selected_product = null;
          console.log("EMITTING REFRESH");
          this.$emit("refresh");
        })
        .catch((err) => {
          this.logError(err);
        })
        .finally(() => {
          this.formLoading = false;
          this.action_dialog = false;
          this.$emit("refresh");
        });
    },
    assignData() {
      if (this.products && this.products.length) {
        this.rowData = this.products;
      } else {
        this.rowData = [];
      }
    },
    openDeleteDialog(item) {
      this.selected_product = item;
      this.action_dialog = true;
    },
  },
  mounted() {
    this.assignData();
  },
};
</script>
